import { render, staticRenderFns } from "./SyncScreen.vue?vue&type=template&id=bb7914c2"
import script from "./SyncScreen.vue?vue&type=script&lang=js"
export * from "./SyncScreen.vue?vue&type=script&lang=js"
import style0 from "./SyncScreen.vue?vue&type=style&index=0&id=bb7914c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports